export const WHATSAPP_CALL_EXPIRATION_MS = 120000;

export const normalizeWhatsAppCallStatus = status =>
  String(status || '')
    .toLowerCase()
    .replaceAll(' ', '_');

export const parseWhatsAppCallTimestamp = value => {
  if (value === undefined || value === null || value === '') return null;

  if (typeof value === 'number' || /^\d+$/.test(String(value))) {
    const numericValue = Number(value);
    const milliseconds =
      numericValue < 100000000000 ? numericValue * 1000 : numericValue;
    return Number.isFinite(milliseconds) ? milliseconds : null;
  }

  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : null;
};

export const whatsappCallStatusTimestamp = (payload = {}, fallback = null) =>
  parseWhatsAppCallTimestamp(
    payload.status_updated_at || payload.timestamp || fallback
  );

export const isWhatsAppCallStatusExpired = ({
  status,
  timestamp,
  now = Date.now(),
}) => {
  const normalizedStatus = normalizeWhatsAppCallStatus(status);
  if (
    ![
      'initiated',
      'incoming',
      'permission_accepted',
      'connect',
      'ringing',
      'pre_accept',
    ].includes(normalizedStatus)
  ) {
    return false;
  }

  const timestampMs = parseWhatsAppCallTimestamp(timestamp);
  return (
    timestampMs === null || now - timestampMs >= WHATSAPP_CALL_EXPIRATION_MS
  );
};

export const isActiveWhatsAppRinging = ({
  status,
  timestamp,
  conversationStatus,
  now = Date.now(),
}) =>
  conversationStatus !== 'resolved' &&
  ['ringing', 'connect'].includes(normalizeWhatsAppCallStatus(status)) &&
  !isWhatsAppCallStatusExpired({ status, timestamp, now });
